// removed by extract-text-webpack-plugin
module.exports = {"discover":"qempo_Discover_discover-1KUeDcQ","green":"qempo_Discover_green-1tK9aVo","circleAndPlay":"qempo_Discover_circleAndPlay-2qdRhFd","white":"qempo_Discover_white-2j7BmkO","lightBlue":"qempo_Discover_lightBlue-w5AQ1w8","orange":"qempo_Discover_orange-1cB3LWY","hasIcon":"qempo_Discover_hasIcon-225NYAV","title":"qempo_Discover_title-t1xAHQA","buttonWrap":"qempo_Discover_buttonWrap-2U68Zea","blink":"qempo_Discover_blink-33wWhTP","iframe":"qempo_Discover_iframe-AiLUhln","close":"qempo_Discover_close-1mQY8hk"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/home/components/Discover/Discover.scss
// module id = 192
// module chunks = 0